module.exports = __webpack_public_path__ + "img/home.61374f23.svg";